import ReactMounter from 'lib/ReactMounter';
import BaseContactPage from 'pages/BaseContactPage/BaseContactPage';

ReactMounter.registerComponentToMountOnLoad('BaseContactPage', BaseContactPage);
